import { CollectionSiteSchema } from '../types/collection-site.type';

export function formatSiteLocation(site: CollectionSiteSchema): string | null {
  const street = site.data?.address?.street?.trim();
  const city = site.data?.address?.city?.trim();
  if (street && city) return `${street}, ${city}`;
  if (street) return street;
  if (city) return city;
  if (site.latitude != null && site.longitude != null) {
    return `${site.latitude}, ${site.longitude}`;
  }
  return null;
}

export function formatSiteDateTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function displayField(value: unknown): string {
  if (value == null) return '—';
  const text = String(value).trim();
  return text || '—';
}
